import { Agent } from "../types";
import { api } from "./base.api";

export const agentsAPI = {
  createAgent: async (agent: Partial<Agent>) => {
    const response = await api.post("/agents", agent);
    return response.data;
  },

  getAgents: async (page: number = 1, limit: number = 5) => {
    const response = await api.get<{
      agents: Agent[];
      pagination: {
        total: number;
        page: number;
        limit: number;
        pages: number;
      };
    }>(`/agents?page=${page}&limit=${limit}`);
    return response.data;
  },

  getAgent: async (id: string) => {
    const response = await api.get<Agent>(`/agents/${id}`);
    return response.data;
  },

  updateAgent: async (id: string, agent: Partial<Agent>) => {
    console.log({ agent });
    const response = await api.patch<Agent>(`/agents/${id}`, agent);
    return response.data;
  },

  deleteAgent: async (id: string) => {
    const response = await api.delete(`/agents/${id}`);
    return response.data;
  },
};
